
export const news = [
  {
    id: 1,
    title: 'Akron Rubber Ducks Interview: Inside the Mental Game',
    excerpt: 'In an exclusive interview with the Akron Rubber Ducks, Zane "Nightmare" Morehouse opens up about the psychological aspects of pitching at the professional level. From pre-game routines to handling pressure situations, discover the mental strategies that make Nightmare one of the most feared pitchers in the organization.',
    date: 'May 15, 2024',
    image: '',
    videoEmbed: 'https://www.youtube.com/embed/oR1sFuDRNvE?si=BYfC6i29_7LsDufR&autoplay=0',
  },
  {
    id: 2,
    title: 'Nightmare Punches Out 4 in 2 IP in the AFL',
    excerpt: 'Zane "Nightmare" Morehouse delivered a dominant performance, striking out 4 batters in just 2 innings of work. His electric fastball and devastating breaking pitches kept hitters off balance throughout his appearance, showcasing the elite stuff that has scouts buzzing about his future potential.',
    date: 'October 15, 2025',
    image: '',
    instagramEmbed: 'https://www.instagram.com/reel/DQkKGnfieqs/',
    thumbnail: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/c41100db693e9832cdb586ba5fd9c731.jpeg',
  },
  {
    id: 3,
    title: 'Triple Play For NIGHTMARE!',
    excerpt: 'An incredible defensive moment as the Akron Rubber Ducks turn a rare triple play! Watch as Nightmare and his teammates execute perfect timing and precision to complete one of baseball\'s most exciting plays. This highlight showcases the exceptional teamwork and athleticism that defines championship baseball.',
    date: 'March 8, 2025',
    image: 'https://public.readdy.ai/ai/img_res/065dc8ae854e2568b2dc492877210200.jpg',
    videoEmbed: 'https://www.mlb.com/video/akron-s-triple-play?partnerId=web_video-playback-page_video-share',
    thumbnail: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/49044f254e72006abd6700990cb286ac.jpeg',
  },
  {
    id: 4,
    title: 'Nightmare On The Move.......',
    excerpt: 'Nightmare promoted to Double A Akron.....',
    date: 'December 15, 2024',
    image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/7cd6111c07df4c07ef6df52ceca42e94.jpeg',
    externalLink: 'https://www.facebook.com/share/v/1ByquwTbRM/',
  },
  {
    id: 5,
    title: 'Zane Morehouse Top 100 Draft Prospect',
    excerpt: 'Zane hosted his first youth baseball clinic in Cleveland, working with over 100 young athletes on pitching mechanics and mental preparation. The event was a huge success, with participants praising his hands-on approach and genuine passion for teaching.',
    date: 'March 1, 2025',
    image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/010311aa9d3ec996ff87544a0eec36d7.jpeg',
    externalLink: 'https://futurestarsseries.com/mlb-draft-top-prospects-college-world-series-dylan-crews-wyatt-langford-troy-lowder-waldrep/',
  },
  {
    id: 6,
    title: 'Morehouse Featured in Baseball America Top 100',
    excerpt: 'Baseball America has included Zane Morehouse in their prestigious Top 100 Prospects list for 2025. Scouts praise his electric stuff, competitive mindset, and rapid development as key factors in his rising stock within the baseball community.',
    date: 'February 28, 2025',
    image: 'https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/fd82b455bb4c197ff9c1f2c2290311dd.jpeg',
  },
];
